<template>
  <div class="relative">
    <input
      v-model="value"
      type="checkbox"
      :id="name"
      :name="name"
      :value="label"
      class="opacity-0 invisible w-0 h-0 absolute top-0 left-0"
    />
    <label
      :for="name"
      :aria-labelledby="`${name}-label`"
      :aria-describedby="`${name}-label`"
      class="flex gap-3 cursor-pointer w-full select-none"
    >
      <i
        class="flex w-6 h-6 items-center justify-center text-xl duration-300 bg-gray-100"
        :class="checkIconWrapperClass"
      >
        <svg
          v-show="value"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            :fill="checkSvgFill"
            d="M9 16.17L4.83 12l-1.42 1.41L9 19L21 7l-1.41-1.41z"
          ></path>
        </svg>
      </i>
      <span
        v-if="label"
        :id="`${name}-label`"
        @click="modal ? modalOpen() : ''"
        class="w-[calc(100%-24px)]"
        :class="checkTextClass"
      >
        {{ label }}
      </span>
    </label>
  </div>
  <PolicyModal
    v-if="modal && policyModalMounted"
    :visible="modalPolicyVisible"
    @update:visible="modalPolicyVisible = $event"
  />
</template>

<script setup>
import { defineAsyncComponent } from "vue";
import { useSiteSettingsStore } from "@/store/index";
const siteSettingsStore = useSiteSettingsStore();
const props = defineProps({
  modelValue: { type: Boolean },
  label: { type: String },
  name: { type: String },
  color: { type: String, default: "white" },
  modal: { type: Boolean, default: false },
  error: { type: Boolean },
});

const emit = defineEmits(["update:modelValue"]);

const value = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

const modalPolicyVisible = ref(false);
const { mounted: policyModalMounted } = useLazyMount(modalPolicyVisible, 250);
const PolicyModal = defineAsyncComponent(
  () => import("~/components/Plugins/Modal/Policy.vue")
);

function modalOpen() {
  modalPolicyVisible.value = true;
}
const checkIconWrapperClass = computed(() => [
  { rounded: siteSettingsStore.roundCorner },
  props.error ? '!border-red-500 border-solid border' : '',
]);
const checkSvgFill = computed(() => [
  props.color === 'white' ? 'text-white' : '',
  props.color === 'black' ? 'text-black' : '',
]);
const checkTextClass = computed(() => [
  props.error ? '!text-red-500' : '',
  props.color === 'white' ? 'text-white' : '',
  props.color === 'black' ? 'text-black' : '',
]);
</script>
